module.exports = __webpack_public_path__ + "static/coinex-c710dfcfc43288d2cc9eac1c8620e153.png";